document.addEventListener("DOMContentLoaded", function() {
    var groups = {};

    // Collect all elements with a data-mh attribute
    var elements = document.querySelectorAll('[data-mh]');

    // Group elements by their data-mh attribute value
    elements.forEach(function(element) {
        var group = element.getAttribute('data-mh');
        if (!groups[group]) {
            groups[group] = [];
        }
        groups[group].push(element);
    });

    // Set heights for each group
    Object.keys(groups).forEach(function(group) {
        var groupElements = groups[group];
        var maxHeight = 0;

        // Find the tallest element in the group
        groupElements.forEach(function(element) {
            element.style.height = 'auto'; // Reset height
            var height = element.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        // Set all elements in the group to the tallest height
        groupElements.forEach(function(element) {
            element.style.height = maxHeight + 'px';
        });
    });
});
